<div id="user-post-uploader">
    <app-basic-file-uploader [multiple]="true" [accept]="attachmentsAccept" (selection)="onSelection($event)"
        (fileError)="onFileError($event)" [reset]="reset$" [sizeLimit]="sizeLimit" [label]="label"
        labelClass="font-size-small font-weight-bold" buttonClass="button file-uploader-button button--small"
        [validationClass]="validationClass"></app-basic-file-uploader>
    <p class="font-size-small text-muted">{{'TEXT_MEDIA_FILE_UPLOADLIMIT' | translate}}</p>
</div>